@if(verifyCodeStep){
<div class="as-main-modal-container">
  <div class="as-section-top">
    <p class="as-header">Confirmar número de teléfono</p>
  </div>
  <div class="as-section-mid">
    <p class="as-info">
      Ingresa el código que hemos enviado por mensaje de texto (SMS) a tu número
      telefónico.
    </p>
    <div class="as-phone-container">
      <div class="as-left-wrapper">
        <div class="as-wrapper-title">Número telefónico ingresado</div>
        <div class="as-wrapper-info">{{ phone }}</div>
      </div>
      @if(!isRegister){
      <button (click)="editNumber()" class="as-wrapper-button as-pointer">
        Editar
      </button>
      }
    </div>
    <div class="as-input-container">
      <div class="digit-input-container">
        <input
          type="text"
          [class]="{ 'digit-input': true, 'error-border': showInvalidCode }"
          maxlength="1"
          #digitInput
          (focus)="removeError()"
          (keydown)="moveToNext($event, 0)"
        />
        <input
          type="text"
          [class]="{ 'digit-input': true, 'error-border': showInvalidCode }"
          maxlength="1"
          #digitInput
          (focus)="removeError()"
          (keydown)="moveToNext($event, 1)"
        />
        <input
          type="text"
          [class]="{ 'digit-input': true, 'error-border': showInvalidCode }"
          maxlength="1"
          #digitInput
          (focus)="removeError()"
          (keydown)="moveToNext($event, 2)"
        />
        <input
          type="text"
          [class]="{ 'digit-input': true, 'error-border': showInvalidCode }"
          maxlength="1"
          #digitInput
          (focus)="removeError()"
          (keydown)="moveToNext($event, 3)"
        />
        <input
          type="text"
          [class]="{ 'digit-input': true, 'error-border': showInvalidCode }"
          maxlength="1"
          #digitInput
          (focus)="removeError()"
          (keydown)="moveToNext($event, 4)"
        />
        <input
          type="text"
          [class]="{ 'digit-input': true, 'error-border': showInvalidCode }"
          maxlength="1"
          #digitInput
          (focus)="removeError()"
          (keydown)="moveToNext($event, 5)"
        />
      </div>
      <p class="as-input-error">
        @if(showInvalidCode){Código de verificación inválido}
      </p>
    </div>
  </div>
  <div class="as-section-bot">
    <div class="as-timer-container">
      <div class="as-left-container">
        <div class="icon-wrapper">
          <mat-icon [svgIcon]="'ic-orange-alert'"></mat-icon>
        </div>
        <div class="as-left-wrapper">
          <div class="as-wrapper-title">Código de verificación enviado</div>
          <div class="as-wrapper-info">
            <countdown
              (event)="handleCountdownEvent($event)"
              [config]="configTime"
            ></countdown>
            minutos restantes
          </div>
        </div>
      </div>
      <button
        (click)="!isRegister ? getCode() : getCodeRegister()"
        [disabled]="!codeRetryAvailable"
        class="as-wrapper-button as-pointer"
      >
        Reenviar código
      </button>
    </div>
    <button
      (click)="!isRegister ? verifyCode() : verifyCodeRegister()"
      class="as-confirm-button"
      mat-flat-button
      color="accent"
      [disabled]="loading || !canVerifyCode"
    >
      <mat-label class="as-font-white as-font-14 as-font-semibold">
        {{ isRegister ? 'Verificar' : 'Ir a resumen de compra' }}
      </mat-label>
    </button>
  </div>
</div>
}@else{
<div class="as-main-modal-container">
  <div class="as-section-top">
    <p class="as-header">Confirmar número de teléfono</p>
    <p class="as-subheader">Estamos a un paso de confirmar tu pedido.</p>
  </div>
  <div class="as-section-mid">
    <p class="as-info">
      Para mantenerte informado sobre tu pedido, por favor verifica tu número de
      teléfono. Así podremos enviarte actualizaciones importantes.
    </p>
    <div class="as-phone-hint-container">
      <div class="icon-wrapper">
        <mat-icon [svgIcon]="'ic-info-blue'"></mat-icon>
      </div>
      <div class="as-left-wrapper">
        <div class="as-wrapper-title">Este paso se realizará una sola vez.</div>
      </div>
    </div>
  </div>
  <div class="as-section-bot">
    <div class="as-phone-input-wrapper">
      <form class="" [formGroup]="phoneValidationForm">
        <mat-form-field color="accent" class="as-font">
          <mat-label>Número de teléfono</mat-label>
          <input matInput formControlName="phone" maxlength="10" />
          @if(phoneValidationForm.get('phone')?.hasError('required')){
          <mat-error>Número requerido</mat-error>
          } @if(phoneValidationForm.get('phone')?.hasError('pattern') ||
          phoneValidationForm.get('phone')?.hasError('minlength')){
          <mat-error>Formato incorrecto</mat-error>
          } @if(phoneValidationForm.get('phone')?.hasError('alreadyExists')){
          <mat-error>El número ya está registrado</mat-error>
          } @if(phoneValidationForm.get('phone')?.hasError('error')){
          <mat-error>Ha ocurrido un error, intenta nuevamente</mat-error>
          }
        </mat-form-field>
      </form>
      <p class="as-input-hint">
        Te enviaremos un mensaje de texto a este número con un código para
        confirmarlo.
      </p>
    </div>
    <button
      (click)="!isRegister ? getCode() : getCodeRegister()"
      class="as-confirm-button"
      mat-flat-button
      color="accent"
      [disabled]="loading || !phoneValidationForm.valid"
    >
      <mat-label class="as-font-white as-font-14 as-font-semibold">
        Continuar
      </mat-label>
    </button>
  </div>
</div>
}
